import {inject, InjectionToken, RendererFactory2} from "@angular/core";
import {DOCUMENT} from "@angular/common";
import {BehaviorSubject, Observable} from "rxjs";

export const CHECK_LAYOUT_DIRECTION_PROVIDER = new InjectionToken<Observable<string>>('check layout direction', {
  factory: () => {
    const documentRef = inject(DOCUMENT);
    const htmlLink = documentRef.querySelector('html');
    const getDirValue = () => htmlLink?.getAttribute('dir') || 'ltr';
    const dirValue = getDirValue();
    const observable$ = new BehaviorSubject(dirValue);
    const mutationObserver = new MutationObserver((records: MutationRecord[]) => {
      const f = records[0];
      if(f.attributeName === 'dir') {
        observable$.next(getDirValue());
      }
    });

    if(htmlLink) {
      mutationObserver.observe(htmlLink, {
        attributes: true
      })
    }

    return observable$;
  }
})
